import styled, { CSSObject } from '@emotion/styled'
import { useState } from 'react'

type Props = {
  switchName: string
  onToggle: (isChecked: boolean) => void
  defaultChecked?: boolean
  color?: string
}

const ToggleSwitchButton = ({
  switchName,
  defaultChecked = false,
  onToggle
}: Props) => {
  const [isChecked, setIsChecked] = useState<boolean>(defaultChecked)

  const handleToggle = (e: React.SyntheticEvent<EventTarget>) => {
    e.preventDefault()
    const newCheckedValue = !isChecked
    setIsChecked(newCheckedValue)
    onToggle(newCheckedValue)
  }

  return (
    <SwitchWrapper>
      <SwitchButton
        data-testid={'toggle-switch-button'}
        onClick={handleToggle}
        isChecked={isChecked}
      >
        <SwitchContent isChecked={isChecked} />
      </SwitchButton>
    </SwitchWrapper>
  )
}

const SwitchWrapper = styled.div(() => ({
  display: 'flex',
  alignItems: 'center'
}))

const SwitchButton = styled.button<{ isChecked: boolean }>(
  ({ isChecked, theme }): CSSObject => ({
    position: 'relative',
    width: '44px',
    height: '22px',
    borderRadius: '16px',
    border: 'none',
    padding: '0',
    cursor: 'pointer',

    backgroundColor: isChecked ? theme.colors.primary : '#BFBFBF',
    transition: 'background-color 300ms'
  })
)

const SwitchContent = styled.span<{ isChecked: boolean }>(({ isChecked }) => ({
  position: 'absolute',
  top: '2px',
  width: '18px',
  height: '18px',
  backgroundColor: '#fff',
  borderRadius: '100%',

  left: isChecked ? '24px' : '2px',
  transition: 'left 300ms'
}))

export default ToggleSwitchButton
